module.exports = __webpack_public_path__ + "static/media/fly0066.7dd3a613.webp";